<section class="container-fluid">
    <div class="main-container">
        <div class="btn-container">
            @if(!isEdit){
            <button class="edit" (click)="toggleEdit()">
                <img [src]="sharedService.imagesUrl + 'edit.svg'" />
                <a>{{'ACCOUNT.EDIT_BTN' | translateIt: {language: sharedService.currentLanguage} |async}}</a>
            </button>
            }
        </div>

        @if(!isEdit){
        <section class="view-container">
            <div class="personal-container">
                <h1 class="personal-heading">{{'ACCOUNT.PERSONAL_INFORMATION.HEADING' | translateIt: {language:
                    sharedService.currentLanguage} |async}}</h1>
                <div class="personal-text-container">
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.WOW_ID' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.wowId}}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.NAME' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.displayName}}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.EMAIL' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.email }}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.PHONE_NUMBER' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.phoneMobileDisplay }}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.DATE_OF_BIRTH' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.dateOfBirth | date:'MM/dd/yyyy'  }}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.PERSONAL_INFORMATION.GENDER' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.profile?.gender | titlecase }}</p>
                    </div>
                </div>
            </div>
            @if(data?.address){
            <div class="personal-container">
                <h1 class="personal-heading">{{'ACCOUNT.ADDRESS_DETAIL.HEADING' | translateIt: {language:
                    sharedService.currentLanguage} |async}}</h1>
                <div class="personal-text-container">
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.ADDRESS' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.addressLine1 }}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.CITY' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.city }}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.STATE' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.state}}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.ZIP_CODE' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.zipCode}}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.COUNTRY' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.country || 'United States'}}</p>
                    </div>
                    <div class="personal-text-line">
                        <p class="sub-heading">{{'ACCOUNT.ADDRESS_DETAIL.TIMEZONE' | translateIt: {language:
                            sharedService.currentLanguage} |async}}</p>
                        <p class="content">{{data?.address?.timeZone}}</p>
                    </div>
                </div>
            </div>
            }
        </section>
        }
        @else {
        <app-edit [data]="data" [timezoneData]="timezoneData" (toggleEdit)="toggleEdit()"
            (refresh)="getPersonalInfo($event)"></app-edit>
        }
    </div>
    <div class="password-container">
        @if (!isPassword) {
        <div class="content-container">
            <p class="change">{{'ACCOUNT.CHANGE_PASSWORD' | translateIt: {language: sharedService.currentLanguage}
                |async}}</p>
            <button class="change-btn" (click)="togglePassword()">
                <a>{{'ACCOUNT.CHANGE_PASSWORD_BTN' | translateIt: {language: sharedService.currentLanguage} |async}}</a>
            </button>
        </div>
        }
        @else {
        <app-change-password (togglePassword)="togglePassword()" (changePassword)="changePassword($event)"
            [heading]="'ACCOUNT.CHANGE_PASSWORD_BTN' | translateIt: {language: sharedService.currentLanguage} |async"></app-change-password>
        }
    </div>
</section>
<div class="toast-wrapper">
    @if(isToast == "success"){
    <div class="w3-container w3-animate-opacity toast">
        <p>{{'ACCOUNT.MESSAGES.SUCCESS' | translateIt: {language: sharedService.currentLanguage} |async}}</p>
        <img [src]="sharedService.imagesUrl + 'success.svg'" />
    </div>
    }
    @else if(isToast == "error"){
    <div class="w3-container w3-animate-opacity toast">
        <p>{{'ACCOUNT.MESSAGES.ERROR' | translateIt: {language: sharedService.currentLanguage}
            |async}}</p>
        <img [src]="sharedService.imagesUrl + 'error.svg'" />
    </div>
    }
</div>
